"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customTableDefaultValue = exports.customTableSchemaValidator = void 0;
const zod_1 = require("zod");
exports.customTableSchemaValidator = zod_1.z.object({
    config: zod_1.z
        .object({
        horizontalScroll: zod_1.z.boolean().optional(),
    })
        .optional(),
    columns: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string().or(zod_1.z.array(zod_1.z.string())),
        Header: zod_1.z.string(),
        defaultCanFilter: zod_1.z.boolean(),
        group_order: zod_1.z.number(),
        summarize: zod_1.z.union([zod_1.z.enum(['both', 'column', 'group']), zod_1.z.boolean()]).optional(),
        summarizeIgnore: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string(), name: zod_1.z.string() })).optional(),
        summarizeRef: zod_1.z.string().optional(),
        type: zod_1.z.string(),
        hide: zod_1.z.boolean().optional(),
    })),
    isGrouped: zod_1.z.boolean().optional(),
    defaultSortBy: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string(), desc: zod_1.z.boolean() })).optional(),
});
const defaultValue = {
    config: {
        horizontalScroll: false,
    },
    columns: [
        {
            id: 'customer_code',
            Header: 'Cliente',
            defaultCanFilter: false,
            group_order: 0,
            type: 'string',
        },
        {
            id: 'commission_category',
            Header: 'Categoria',
            defaultCanFilter: false,
            group_order: 1,
            type: 'string',
        },
        {
            id: 'commission_name',
            Header: 'Produto',
            defaultCanFilter: false,
            group_order: 0,
            type: 'string',
        },
        {
            id: 'commission_earnings_before_tax',
            Header: 'Valor vendido',
            defaultCanFilter: false,
            group_order: 0,
            type: 'currency',
            summarize: true,
        },
        {
            id: 'creditor_percentage',
            Header: 'Divisão',
            defaultCanFilter: false,
            group_order: 0,
            type: 'percentage',
        },
        {
            id: 'creditor_earnings_before_tax',
            Header: 'Valor Comissionado sem imposto',
            defaultCanFilter: false,
            group_order: 0,
            type: 'currency',
            summarize: true,
        },
        {
            id: 'creditor_earnings_after_tax',
            Header: 'Valor Comissionado',
            defaultCanFilter: false,
            group_order: 0,
            type: 'currency',
            summarize: true,
        },
    ],
    defaultSortBy: [
        {
            id: 'customer_code',
            desc: true,
        },
    ],
    isGrouped: true,
};
exports.customTableDefaultValue = JSON.stringify(defaultValue, null, '\t');
